export default __webpack_public_path__ + "1cdf1fc7a68b9be61e9db5d2bd70a250.png";